import styled, { css } from 'styled-components';
import tickCircle from '~/assets/icons/tick_circle.svg';
import { Text } from '../Text';

const StyledItemsContainer = styled.div<{ $height?: string }>`
	width: 100%;
	max-height: ${(props) => props.$height || '290px'};
	display: flex;
	flex-direction: column;
	padding: 0 20px 0 10px;
	background-color: rgba(255, 255, 255, 0.9);
	border: 1px solid #ffffff;
	z-index: 4;
	border-radius: 10px;
`;

const StyledSelectItem = styled.div`
	display: flex;
	align-items: center;
	height: 40px;
	gap: 10px;

	${Text} {
		color: #000000;
		font-size: 14px;
		font-weight: 400;
		transition: color 0.3s ease;
	}
`;

const StyledItemsContainerInner = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding: 10px 0;
`;

const StyledSelectIcon = styled.div`
	width: 20px;
	height: 20px;
	min-width: 20px;
	min-height: 20px;
	mask-position: center;
	mask-repeat: no-repeat;
	mask-image: url(${tickCircle});
	mask-size: 20px 20px;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-image: url(${tickCircle});
	-webkit-mask-size: 20px 20px;
	background-color: #ffffff;
	transition: background-color 0.3s ease;
`;

const StyledSelectItemWrapper = styled.div<{
	$disabled?: boolean;
	$scrollbar?: boolean;
	$active?: boolean;
}>`
	background-color: transparent;
	border-radius: 5px;
	padding: 0 10px;
	transition:
		background-color 0.3s ease,
		padding 0.3s ease;

	${(props) =>
		props.$active &&
		css`
			background-color: #2d70da;

			${StyledSelectItem} {
				${Text} {
					color: #ffffff;
				}
			}
		`}

	${(props) =>
		!props.$disabled &&
		css`
			&:hover {
				padding: 0 10px;
				background-color: #000000;

				${StyledSelectItem} {
					${Text} {
						color: #ffffff;
					}
				}
			}

			&,
			& * {
				cursor: pointer;
			}
		`}

	${(props) =>
		props.$disabled &&
		css`
			${StyledSelectItem} {
				${Text} {
					color: rgba(255, 255, 255, 0.25);
				}
			}
		`}
`;

export {
	StyledItemsContainer,
	StyledItemsContainerInner,
	StyledSelectIcon,
	StyledSelectItem,
	StyledSelectItemWrapper,
};
